export const readQueuedReportMessage = async (blob) => {
  const response = JSON.parse(await blob.text());
  if (response.isSuccess !== true || response.result?.queued !== true) {
    throw new Error(response.message || "Could not queue report");
  }
  return response.message || "Report queued";
};
